import { render, staticRenderFns } from "./FileListItemPdf.vue?vue&type=template&id=3546da82&"
import script from "./FileListItemPdf.vue?vue&type=script&lang=js&"
export * from "./FileListItemPdf.vue?vue&type=script&lang=js&"
import style0 from "./FileListItemPdf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports